/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiplomeCertificationFichierDto
 */
export interface DiplomeCertificationFichierDto {
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierDto
     */
    iddiplomeCertificationFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierDto
     */
    iddiplomeCertification?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DiplomeCertificationFichierDto interface.
 */
export function instanceOfDiplomeCertificationFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationFichierDtoFromJSON(json: any): DiplomeCertificationFichierDto {
    return DiplomeCertificationFichierDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddiplomeCertificationFichier': !exists(json, 'iddiplomeCertificationFichier') ? undefined : json['iddiplomeCertificationFichier'],
        'iddiplomeCertification': !exists(json, 'iddiplomeCertification') ? undefined : json['iddiplomeCertification'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DiplomeCertificationFichierDtoToJSON(value?: DiplomeCertificationFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddiplomeCertificationFichier': value.iddiplomeCertificationFichier,
        'iddiplomeCertification': value.iddiplomeCertification,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

